<template>
  <div class="text-brand-black-secondary">
    <FilevaliditySkeleton v-if="isLoading"></FilevaliditySkeleton>
    <template v-else>
      <Form
        v-slot="{ errors, values, resetForm, setFieldValue }"
        class="flex flex-col gap-y-5"
        @submit="(values) => onSubmit(values)"
      >
        <fieldset class="border-2 border-primary rounded p-4 flex flex-col gap-y-5">
          <legend class="px-4 text-xl">{{ $t('SearchForAppointment') }}</legend>
          <div class="w-full flex flex-wrap gap-y-2">
            <Field
              :rules="isRequired && isValidEmail"
              name="searchAppointmentCriteria.applicantEmailAddress"
              v-slot="{ field, errors: errs }"
            >
              <SimpleTextInput
                :field="field"
                :errors="errs"
                :label="$t('email')"
                class="w-1/2 pe-6"
                direction="flex-col"
              />
            </Field>
            <Field
              name="searchAppointmentCriteria.singleReferenceNumber"
              v-slot="{ field, errors: errs }"
            >
              <SimpleTextInput
                :field="field"
                :errors="errs"
                :label="$t('referanceNumber')"
                :is-required="false"
                class="w-1/2"
                direction="flex-col"
              />
            </Field>
            <Field name="searchAppointmentCriteria.requestNumber" v-slot="{ field, errors: errs }">
              <SimpleTextInput
                :field="field"
                :errors="errs"
                :label="$t('RequestNumber')"
                :is-required="false"
                class="w-1/2 pe-6"
                direction="flex-col"
              />
            </Field>
            <Field name="searchAppointmentCriteria.pranNumber" v-slot="{ field, errors: errs }">
              <SimpleTextInput
                :field="field"
                :errors="errs"
                :label="$t('eidapran')"
                :is-required="false"
                class="w-1/2"
                direction="flex-col"
              />
            </Field>
          </div>
        </fieldset>
        <fieldset class="border-2 border-primary rounded p-4 flex flex-col items-center gap-y-5">
          <legend class="px-4 text-lg">{{ $t('verifyApplicant') }}</legend>
          <GRecaptcha
            ref="gRecaptchaRef"
            @successCallback="(args) => setFieldValue('recaptchaResponse', args)"
          ></GRecaptcha>
        </fieldset>
        <div class="flex justify-end gap-x-2">
          <button
            class="rounded-md bg-brand-gray-600 flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
            @click.prevent="resetForm"
          >
            <span class="px-1.5 ltr:font-sans tracking-wide text-white text-sm pb-[1px]">
              {{ $t('reset') }}
            </span>
          </button>
          <button
            class="rounded-md bg-primary/80 hover:bg-primary flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
          >
            <div class="flex justify-center items-center h-full bg-black/10 p-2 rounded-s">
              <faMagnifyingGlass class="w-3 fill-white" />
            </div>
            <span class="px-1.5 ltr:font-sans tracking-wide text-white text-sm pb-[1px]">
              {{ $t('search') }}
            </span>
          </button>
        </div>
      </Form>
    </template>
  </div>
</template>

<script setup>
import { Field, Form } from 'vee-validate'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import GRecaptcha from '@/components/GRecaptcha/index.vue'
import faMagnifyingGlass from '@/assets/icons/faMagnifyingGlass.svg?component'
import axios from '@/services'

async function onSubmit(values) {
  const {
    searchAppointmentCriteria: {
      applicantEmailAddress,
      pranNumber,
      requestNumber,
      singleReferenceNumber
    }
  } = values

  const payload = {
    filter: {
      applicantEmailAddress,
      pranNumber,
      requestNumber,
      singleReferenceNumber
    },
    pageIndex: 0,
    pageSize: 10
  }

  const data = await axios.post('/api/appointments/search', payload)
}
</script>

<style lang="scss" scoped></style>
